import React from 'react';
import PropTypes from 'prop-types';

function Icon(props) {
  const myClass = `icon ${props.className}`;
  const icon = <i className={myClass} id={props.id} data-testid="Icon" />;
  return props.text ? (
    <div className="row row--middle row--nowrap row--no-margins">
      <div className="padding-half--right">{icon}</div>
      <div className={!props.multiLine ? 'text--lines-one' : ''}>
        <span>{props.text}</span>
      </div>
    </div>
  ) : (
    icon
  );
}
Icon.defaultProps = {
  text: null,
  multiLine: false,
  id: null
};
Icon.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string.isRequired,
  id: PropTypes.string,
  multiLine: PropTypes.bool
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/ui/Icon.jsx